import { Box, Button, Stack } from "@mui/material";

type FormFooterProps = {
  isSubmitting?: boolean;
  disable?: boolean;
};

const FormFooter = ({
  isSubmitting = false,
  disable = false,
}: FormFooterProps) => (
  <Box
    sx={{
      py: 1,
      px: 2,
      position: "sticky",
      bottom: 0,
      backgroundColor: "background.paper",
      borderTop: "1px solid",
      borderColor: "divider",
      zIndex: 1,
      m: 0,
    }}
  >
    <Stack
      direction="row"
      spacing={1.5}
      justifyContent="center"
    >
      <Button
        type="submit"
        variant="contained"
        color="primary"
        size="large"
        fullWidth
        disabled={disable || isSubmitting}
      >
        {isSubmitting ? "Saving..." : "Save"}
      </Button>
    </Stack>
  </Box>
);

export default FormFooter;
